import React from 'react';
import { FaPiggyBank } from 'react-icons/fa';
import '../../styles/global.css';
import Treasury from './Treasury';
import Security from './Security';

export default function TreasuryAndSecurity() {
  return (
    <section className="admin-overview admin-treasury-security-section">
      <div className="dashboard-header treasury-header">
        <div className="welcome-section">
          <h2 className="dashboard-title treasury-title">
            <FaPiggyBank className="treasury-icon"/> Treasury & Security
          </h2>
        </div>
      </div>
      <div className="treasury-security-row">
        <div className="treasury-security-card"><Treasury /></div>
        <div className="treasury-security-card"><Security /></div>
      </div>
    </section>
  );
}
